{
  "ontology": "Data model",
  "sources": "Documents",
  "threads": "Runs",
  "workflows": "Process schemas"
}
